// js
import Recommendations from '../../../components/analytics/pptx/Recommendations';
import { getAdoptionGoalsWithAreas } from '../../../selectors/analytics/adoptionSelectors';
import { connect } from 'react-redux';


const mapStateToProps = (state, props) => {
  return {
    adoptionGoalsWithAreas: getAdoptionGoalsWithAreas(0)((state, props)),
    dsaGoals: state.dsa && state.dsa.dsaGoals || []
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Recommendations);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/RecommendationsTwo.js